import { render } from "./OnBoardingWrapper.vue?vue&type=template&id=03e760df"
import script from "./OnBoardingWrapper.vue?vue&type=script&lang=js"
export * from "./OnBoardingWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__